import styled from 'styled-components'

export const ClassifiedListGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(432px, 1fr));
  column-gap: 16px;
  row-gap: 8px;
  padding: 24px;
`
